<template>
  <div class="home">
    <Head />
    <div class="partner">
      <p class="tit02_app">来自30万家客户的信赖</p>
      <div class="box">
        <img class="el-image" src="../../static/imgs/home/partner.jpg" />
      </div>
      <button class="know">
        <router-link to="/serviceCase" target="_blank"
          >了解服务案例<span class="icon el-icon-right"
        /></router-link>
      </button>
    </div>
    <!-- <div class="information">
      <div class="title">
        <img src="../../static/imgs/home/line.png" alt="" />
        <span>资讯中心</span>
        <img style="transform:rotateY(180deg);" src="../../static/imgs/home/line.png" alt="" />
      </div>
      <section class="expertThinkTank_center title_item">
        <div v-for="(item, index) in zixunTypes" :key="index">
          <el-divider v-if="index != 0" direction="vertical" />
          <span :class="zx == index ? 'checked' : 'pointer'" @click="getZixunList(index)">{{ item.FullName }}</span>
        </div>
      </section>
      <section class="dongtaiContent">
        <div class="div_zixun">
          <dl v-for="(item, index) in list" :key="index">
            <dt><a :title="item.fTittle" @click="articleDetail(item)">{{ item.fTittle }}</a>
            </dt>
            <dd class="date_zixun">{{ item.fReleaseDate }}</dd>
            <dd class="img_zixun">
              <img :src="$urlFile + item.fCover" alt="" />
            </dd>
            <dd class="content_zixun">{{ item.fSynopsis }}</dd>
          </dl>
        </div>
      </section>
      <div class="more">
        <router-link to="/information">查看更多<span class="icon el-icon-right" /></router-link>
      </div>
    </div> -->
    <div class="bag">
      <div class="matrixConcent" id="position6-4">
        <div class="matrixTitle">
          <h1>集团矩阵</h1>
        </div>
        <div class="matrixBody">
          <div class="matrixParagraph">
            <p>
              线上+线下交易服务平台+智库平台联动，以期实现多领域的人才联合、智力联合、资源整合，帮助合作伙伴明确战略，发展创新，提高整体竞争优势，助力企业实现高质量发展
            </p>
          </div>
          <ul class="classify">
            <li class="classification1">
              <div class="numberTotal">
                <div class="number">1</div>
                <div class="squad">个集团</div>
              </div>
              <div class="battleArray">鼎宏集团</div>
            </li>
            <li class="classification2">
              <div class="numberTotal">
                <div class="number">1</div>
                <div class="squad">个聚集区</div>
              </div>
              <div class="battleArray">昆明市知识产权聚集区</div>
            </li>
            <li class="classification3">
              <div class="numberTotal">
                <div class="number">3</div>
                <div class="squad">大运营中心</div>
              </div>
              <div class="battleArray">
                北京行政中心<br />
                中西部运营中心<br />
                南亚东南亚运营中心
              </div>
            </li>
            <li class="classification4">
              <div class="numberTotal">
                <div class="number">5</div>
                <div class="squad">大服务平台</div>
              </div>
              <div class="battleArray">
                鼎智云IP<br />
                创新大学堂<br />
                西部农业品牌研究院<br />
                北京中振兴农业科技研究院<br />
                中国-南亚东南亚国际技术转移交易网
              </div>
            </li>
            <li class="classification5">
              <div class="numberTotal">
                <div class="number">8</div>
                <div class="squad">大服务领域</div>
              </div>
              <div class="battleArray">
                知识产权代理服务 <br />知识产权咨询服务<br />
                知识产权信息化服务<br />
                知识产权法律服务<br />
                知识产权商用化服务 <br />互联网与科技应用服务<br />
                品牌运营服务<br />
                培训服务
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <comFooter />
  </div>
</template>
<script>
import index from "./home.js";
import Head from "../components/head.vue";
import { getCodeLsit, getNewsList } from "../request/api.js";

export default {
  name: "home",
  components: {
    index,
    Head,
  },
  data() {
    return {
      zx: 0,
      zixunTypes: [],
      list: [],
      platform: [
        { id: 1, src: require("../../static/imgs/home/bjzz.png"), link: "" }, //网址待添加
        {
          id: 2,
          src: require("../../static/imgs/home/jyw.png"),
          link: "http://yx.csettn.com/",
        }, //网址待确认
        { id: 3, src: require("../../static/imgs/home/cxdxt.png"), link: "" }, //网址待添加
        {
          id: 4,
          src: require("../../static/imgs/home/wab.png"),
          link: "http://www.wabi.org.cn/",
        }, //网址待确认
        { id: 5, src: require("../../static/imgs/home/dzy.png"), link: "" }, //网址待添加
      ],
      partner: [
        {
          id: 1,
          name: "云南省科学技术情报研究院",
          link: "http://www.istiy.yn.cn/",
        },
        { id: 2, name: "四川泽实律师事务所", link: "" }, //网址待添加
        { id: 3, name: "云游碳汇", link: "http://www.ytcarbonsink.com/" }, //网址待确认
        { id: 4, name: "四川品牌建设促进会知识产权专业委员会", link: "" }, //网址待添加
        {
          id: 5,
          name: "中国（云南）自由贸易试验区昆明片区知识产权运营服务中心",
          link: "http://www.ynftaip.cn/",
        },
      ],
    };
  },
  mounted() {
    this.getZixunTypes();
  },
  methods: {
    tozhuanjia() {
      this.$router.push({
        name: "expertThinkTank",
      });
    },
    toUrl(url) {
      // window.location.href = url;
      window.open(url, "blank");
    },
    articleDetail(item) {
      this.$router.push({
        path: "/articleDetail",
        query: {
          id: item.fNewsId,
          typeText: this.zixunTypes[this.zx].FullName,
        },
      });
    },
    getZixunList(zx) {
      this.zx = zx;
      let data = {
        fClass: this.zixunTypes.length > 0 ? this.zixunTypes[zx].Value : 0,
        PageInfo: {
          PageIndex: 1,
          PageSize: 4,
          Sort: "fReleaseDate",
          SortOrder: "desc",
        },
      };
      getNewsList(data).then((data) => {
        data.Result.map((item) => {
          item.fCreateDate = item.fCreateDate.split("T")[0];
          item.fReleaseDate = item.fReleaseDate.split("T")[0];
        });
        this.list = data.Result;
      });
    },
    getZixunTypes() {
      getCodeLsit({ code: "NewsType" }).then((data) => {
        if (data.StatusCode == 200) {
          this.zixunTypes = data.Result || [];
          this.getZixunList(0);
        } else console.log(data.Msg);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/style/index.scss";

.el-divider--vertical {
  margin: 0 8px !important;
}

.home {
	// width: 70vw;
	margin: 0 auto;
  .partner {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    background: #fff;

    p {
      width: 100%;
      //font-size: 36px;
      font-size: 2.25rem;
      color: #333;
      margin: 3.5rem 0 1.5rem 0;
      text-align: center;
    }

    .box {
      width: 100%;
      overflow: hidden;

      .el-image {
        width: 100%;
        cursor: default;
        transform: scale(1);
        transition: all 0.1s ease;
        -webkit-transition: all 0.6s ease;
        -moz-transition: all 0.6s ease;
        -ms-transition: all 0.6s ease;
        -o-transition: all 0.6s ease;
      }

      .el-image:hover {
        transform: scale(1.4);
      }
    }

/*     @media screen and (max-width: 600px) {
      .box {
        height: 10rem;
      }
    } */

    .know {
      width: 160px;
      height: 48px;
      background: #0055a2 !important;
      margin: 2.5rem 0 3rem 0;

      a {
        color: #fff;
        font-size: 14px;
      }

      .icon {
        color: #fff;
        padding-left: 0.5rem;
      }
    }
  }
 
  @media screen and(max-width: 500px) {
    .partner{
      p{
        // font-size: 5rem;
        color: #333;
        font-weight:400;
      }
    }
   }
  .bag {
    background-image: linear-gradient(#f5f7fa, #fff);
  }

  .information {
    margin: 5rem auto;

    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 2rem 0 1rem 0;

      span {
        color: #3b426b;
        font-size: 2.25rem;
        margin: 0 0.5rem;
      }

      img {
        width: auto;
      }
    }

/*     @media screen and (max-width: 600px) {
      .title {
        span {
          font-size: 1.3rem;
        }

        img {
          width: 10rem;
        }
      }
    } */

    .title_item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      margin: 2.5rem auto;

      .pointer {
        cursor: pointer;
      }

      div {
        font-size: 0.875rem;
      }

      .checked {
        color: #0055a2;
      }
    }

    .dongtaiContent {
      max-width: 1200px;
      margin: 30px auto;

      .div_zixun {
        background: #fff;
        padding: 2.8em 20px 0 20px;
        display: flex;
        flex-wrap: wrap;

        dl {
          flex: 0 0 47%;
          padding-left: 180px !important;
          margin-bottom: 2.8em !important;
          position: relative;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          box-sizing: border-box;
          margin: 0;
          padding: 0;
          line-height: 1.5;
          font-size: 14px;
          height: 120px;
        }

        dl:nth-of-type(2n) {
          margin-left: 6%;
        }

        dt {
          font-size: 20px;
          font-weight: 400;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          line-height: 120%;
          margin: 0.2em 0 0.5em;

          a {
            color: #333;
            text-decoration: none;
            background-color: transparent;
            outline: none;
            cursor: pointer;
            transition: color 0.3s;
          }
        }

        .date_zixun {
          order: -1;
          margin: 0;
        }

        .img_zixun {
          position: absolute;
          left: 0;
          top: 0;
          margin: 0;

          img {
            width: 160px;
            height: 120px;
            background-color: aliceblue;
          }
        }

        .content_zixun {
          height: 20px;
        }
      }

/*       @media screen and (max-width: 600px) {
        .div_zixun {
          display: block;

          dl:nth-of-type(2n) {
            margin-left: 0%;
          }
        }
      } */
    }

    .more {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #333;
      font-size: 14px;
      cursor: pointer;
      margin-bottom: 2rem;

      span {
        margin-left: 0.3rem;
      }
    }
  }

  .matrix {
    width: 100%;
    background: url("../../static/imgs/home/matrix.png") no-repeat;
    background-size: cover;

    .bloc {
      width: 95vw;
      margin: 0 auto;
      padding: 2rem 0;

      .title {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 2rem 0 1rem 0;

        span {
          color: #fff;
          font-size: 2rem;
          margin: 0 0.5rem;
        }

        img {
          width: auto;
        }
      }

/*       @media screen and (max-width: 600px) {
        .title {
          span {
            font-size: 1.3rem;
          }

          img {
            width: 8rem;
          }
        }
      } */

      .juzhenContent {
        padding: 1rem 0;
        display: flex;
        flex-wrap: wrap;

        .matrix_item {
          display: flex;
          flex-wrap: wrap;

          .header {
            width: 12rem;
            height: 5rem;
            background: url("../../static/imgs/home/customer-nav-line.png")
              no-repeat 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-right: 0.3rem;

            span {
              color: #fff;
              padding-left: 2rem;
            }
          }

          .item {
            width: 12rem;
            height: 5rem;
            margin: 0 0.3rem 1rem 0.3rem;
            overflow: hidden;

            a {
              img {
                width: 12rem;
                height: 5rem;
              }
            }
          }

/*           @media screen and (max-width: 1366px) {
            .item {
              width: 9.2rem;

              a {
                img {
                  width: 9.2rem;
                }
              }
            } 
          }

          @media screen and (max-width: 600px) {
            .header {
              width: 100vw;
            }

            .item {
              width: 6rem;
              height: 3rem;

              a {
                img {
                  width: 6rem;
                  height: 3rem;
                }
              }
            }
          }*/

          .item:last-child {
            margin-right: 0;
          }
        }

        .partner_item {
          display: flex;
          flex-wrap: nowrap;

          .header {
            min-width: 12rem;
            height: 5rem;
            background: url("../../static/imgs/home/customer-nav-line.png")
              no-repeat 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-right: 0.3rem;

            span {
              color: #fff;
              padding-left: 2rem;
            }
          }

          .partner {
            background: none !important;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;

            .item {
              width: auto;
              height: 2rem;
              background: rgba(5, 5, 5, 0.2);
              border: 1px solid #999;
              padding: 0 1rem;
              margin: 0 0.3rem;
              display: flex;
              justify-content: center;
              align-items: center;

              span {
                color: #fff;
                font-size: 14px;
              }
            }
          }
        }

/*         @media screen and(max-width: 600px) {
          .partner_item {
            display: flex;
            flex-wrap: wrap;

            .header {
              width: 100vw;
            }

            .partner {
              display: list-item;

              .item {
                height: 3rem;
                margin: 0.3rem 0;

                span {
                  color: #fff;
                  font-size: 14px;
                }
              }
            }
          }
        } */
      }
    }
  }
}

.headTab {
  border-bottom: 1px solid white;
  color: white;
  display: flex;
  justify-content: center;
  padding: 20px;

  div {
    margin-right: 20px;
    cursor: pointer;
  }

  div:hover {
    color: wheat;
  }
}

.jianshuItem {
  display: flex;
  width: 63vw;
  justify-content: space-between;
  padding: 20px 0;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.301);
  bottom: -40px;
  position: absolute;

  .jianshuItemItem {
    width: 22%;
    border-right: 2px solid #dedede;

    p {
      text-align: center;
      font-size: 14px;
    }

    p:nth-child(1) {
      font-size: 36px;
      font-weight: 600;
      margin-bottom: 6px;
    }
  }
}

.seeMoreBtn {
  font-size: 14px;
  border: 1px solid #dedede;
  color: #666;
  display: inline-block;
  padding: 6px 10px;
  margin-top: 20px;
  cursor: pointer;
}

.seeMoreBtn:hover {
  background: #666;
  color: white;
}

.expertThinkTank_center_content {
  display: flex;
  justify-content: space-between;
}

.demo {
  width: 600px;
  height: 338px;
  text-align: center;
  line-height: 100px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  // background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}

.video-player {
  width: 600px;
  height: 338px;
}

.video-js .vjs-big-play-button {
  width: 72px;
  height: 72px;
  border-radius: 100%;
  z-index: 100;
  background-color: #ffffff;
  border: solid 1px #979797;
}

.matrixConcent {
  max-width: 1200px;
  margin: 3.5rem auto;
  padding-top: 1rem;

  .matrixTitle {
    background: url(../../static/imgs/regardDH/juzhen-01.jpg) no-repeat bottom;
    padding: 3.75rem 0 2.9rem 2.75rem;

    h1 {
      font-size: 2.25rem;
      color: #333;
    }
  }

  .matrixBody {
    background: url(../../static/imgs/regardDH/juzhen-02.jpg) no-repeat top;
    padding: 7.125rem 1rem 2.9rem 1rem;

    .matrixParagraph {
      width: 40%;
      padding-bottom: 8.75rem;
      padding-left: 1.9rem;

      p {
        font-size: 1rem;
        color: #fff;
        width: 100%;
        line-height: 1.6rem;
      }
    }

    .classify {
      margin: 0 auto;
      display: flex;
      justify-content: space-between;

      .classification1 {
        background: #fff;
        margin-right: 1.25rem;
        padding: 2.4rem 1.9rem 7.25rem 1.25rem;
        background: url(../../static/imgs/regardDH/icon-1.png) no-repeat top;
      }

      .classification2 {
        background: #fff;
        margin-right: 1.25rem;
        padding: 2.4rem 1.9rem 7.25rem 1.25rem;
        background: url(../../static/imgs/regardDH/icon-2.png) no-repeat top;
      }

      .classification3 {
        background: #fff;
        margin-right: 1.25rem;
        padding: 2.4rem 1.9rem 2.75rem 1.25rem;
        background: url(../../static/imgs/regardDH/icon-3.png) no-repeat top;
      }

      .classification4 {
        background: #fff;
        margin-right: 1.25rem;
        padding: 2.4rem 1.9rem 2.25rem 1.25rem;
        background: url(../../static/imgs/regardDH/icon-4.png) no-repeat top;
      }

      .classification5 {
        background: #fff;
        padding: 2.4rem 1.9rem 2.25rem 1.25rem;
        background: url(../../static/imgs/regardDH/icon-5.png) no-repeat top;
      }

      .numberTotal {
        display: flex;
        align-items: center;
        margin-bottom: 1.25rem;

        .number {
          font-size: 1.75rem;
          color: #fff;
          background: #0055a2;
          width: 2.5rem;
          height: 2.5rem;
          border-radius: 50rem;
          text-align: center;
          margin-right: 0.625rem;
        }

        .squad {
          font-size: 1.25rem;
          color: #0055a2;
          font-weight: bold;
        }
      }

      .battleArray {
        font-size: 0.875rem;
        color: #333;
        line-height: 1.6rem;
      }
    }
  }
}
@media screen and (max-width: 500px) {
	.home{
		width: 100vw;
		
	}
}
@media screen and (max-width: 500px) {
  
  .matrixConcent {
    .matrixTitle {

      padding: 1rem 0 2.9rem 2.75rem;
    h1 {
      // font-size: 7.25rem;
      color:#0055a2;
      // font-weight: 600;
    }
  }
    .matrixBody{
      background: url(../../static/imgs/regardDH/juzhen-02-app.jpg) ;
      
      .matrixParagraph{
        width: 90%;     
        p{
          // font-size: 5rem !important;
          // line-height:6.5rem;
        }
      }
      .classify {
      margin: 0 auto;
      display: flex;
	  // width: 100vw;
      //flex-direction: column;
      //justify-content: flex-start;
      flex-wrap: wrap;

      .classification1 {
		  padding: 10px 5px;
        width: 90%;
        background: #fff;
        margin-right: 0;
        // padding: 2.4rem 1.9rem 2.4rem 1rem !important;
        // margin-left: 10px !important;
        // margin-bottom: 10px !important;
      }
      .classification2 {
		  padding: 10px 5px;
        width: 90%;
        background: #fff;
        margin-right: 0;
        // padding: 2.4rem 1.9rem 2.4rem 1rem !important;
        // margin-left: 10px !important;
        // margin-bottom: 10px !important;
      }
      .classification3 {
		  padding: 10px 5px;
        width: 90%;
        background: #fff;
        margin-right: 0;
        // padding: 2.4rem 1.9rem 2.4rem 1rem !important;
        // margin-left: 10px !important;
        // margin-bottom: 10px !important;
      }
      .classification4 {
		  padding: 10px 5px;
        width: 90%;
        background: #fff;
        margin-right: 0;
        // padding: 2.4rem 1.9rem 2.4rem 1rem !important;
        // margin-left: 10px !important;
        // margin-bottom: 10px !important;
      }
      .classification5{
		  padding: 10px 5px;
        width: 90%;
        background: #fff;
        margin-right: 0;
        // padding: 2.4rem 1.9rem 2.4rem 1rem !important;
        // margin-left: 10px !important;
        // margin-bottom: 10px !important;
      }

      .numberTotal {
        display: flex;
        align-items: center;
        // margin-bottom: 5.25rem;
        .number {
          // font-size: 5.5rem!important;
          color: #fff;
          background: #0055a2;
          // width: 8rem !important;
          // height:8rem !important;
          // border-radius: 44rem;
          text-align: center;
          margin-right: 0.625rem;
        }

        .squad {
        // font-size:5.5rem !important;
        color: #0055a2;
        font-weight: bold;
      }
    }
       .battleArray {
        // font-size: 4.6rem !important;
        color: #333;
        // line-height: 6rem !important;
    }
    }
    }
          
  }
  
}
/* @media screen and (max-width: 500px) {
  .bag {
    background-image: linear-gradient(#fff, #f5f7fa, #fff) !important;
  }
  .matrixConcent {
    margin: 0;
    padding-top: 0;
  }
  .matrixTitle {
    background: url(../../static/imgs/home/bg-01.jpg) no-repeat bottom !important;
    padding: 45px 0 65px 45px;
    h1 {
      font-size: 36px;
      color: #333;
    }
  }
  .matrixBody {
    background: url(../../static/imgs/home/bg-02.png) no-repeat top !important;
    padding: 0 !important;
   
  }
  .matrixParagraph {
    width: 100% !important;
    padding-bottom: 30px !important;
    padding-top: 30px !important;
    p {
      font-size: 18px !important;
      color: #fff;
      line-height: 36px !important;
      width: 90% !important;
    }
  }
  .classify {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    padding-bottom: 30px !important;
    .classification1 {
      background: #fff;
      margin-right: 0;
      padding: 2.4rem 1.9rem 2.4rem 1.25rem !important;
      background: url(../../static/imgs/home/icon-01.png) no-repeat top !important;
      margin-left: 20px !important;
      margin-bottom: 20px !important;
    }

    .classification2 {
      background: #fff;
      margin-right: 0;
      padding: 2.4rem 1.9rem 2.4rem 1.25rem !important;
      background: url(../../static/imgs/home/icon-02.png) no-repeat top !important;
      margin-left: 20px !important;
      margin-bottom: 20px !important;
    }

    .classification3 {
      background: #fff;
      margin-right: 0;
      padding: 2.4rem 1.9rem 2.4rem 1.25rem !important;
      background: url(../../static/imgs/home/icon-03.png) no-repeat top !important;
      margin-left: 20px !important;
      margin-bottom: 0 !important;
    }

    .classification4 {
      background: #fff;
      margin-right: 0;
      padding: 2.4rem 1.9rem 2.4rem 1.25rem !important;
      background: url(../../static/imgs/home/icon-04.png) no-repeat top !important;
      margin-left: 20px !important;
      margin-bottom: 0 !important;
    }

    .classification5 {
      background: #fff;
      margin-right: 1.25rem !important;
      padding: 2.4rem 1.9rem 2.4rem 1.25rem !important;
      background: url(../../static/imgs/home/icon-05.png) no-repeat top !important;
      margin-left: 20px !important;
      margin-bottom: 10px !important;
    }

    .numberTotal {
      display: flex;
      align-items: center;
      margin-bottom: 1.25rem;

      .number {
        font-size: 28px !important;
        color: #fff;
        background: #0055a2;
        width: 2.4rem !important;
        height:2.4rem !important;
        border-radius: 50rem;
        text-align: center;
        margin-right: 0.625rem;
      }

      .squad {
        font-size: 24px !important;
        color: #0055a2;
        font-weight: bold;
      }
    }

    .battleArray {
     font-size: 18px !important;
      color: #333;
      line-height: 1.6rem;
      line-height: 34px !important;
    }
  } 
} */
</style>
